import {
  CBA_RULE,
  COND,
  EQ,
  GT,
  GTE,
  IS_NOT,
  LEFT,
  LT,
  LTE,
  OP,
  RIGHT,
} from "../../misc/RuleObjectTypes";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { RulesContext } from "../../RulesContext";
import Filters from "./filters/Filters";
import SubConditionFilter from "./filters/SubConditionFilter";
import Label from "../../../../Common/components/Label";
import { LeftButton, RightButton } from "../LeftButton";
import { DeleteIcon } from "assests/GmsIcons";


let savedFiltersLeft;
let savedFiltersRight;
const SubCondition = ({ rule, element }) => {
  const { ruleType, attributesList, selectedCategories, ruleDispatch } =
  useContext(RulesContext);
  let position = element.position;

  const [leftAttrID, setLeftAttrID] = useState("");
  const [rightAttrID, setRightAttrID] = useState("");
  const [subConditionOp, setSubConditionOp] = useState("");
  /* Which side's Filters dialog is open (LEFT | RIGHT | null). Replaces the
     Bootstrap data-bs-toggle plumbing (okf/rules § 4.4): the dialog is a DS
     Dialog now, and open/close is plain React state. One side at a time, as
     two Bootstrap modals could never stack here either. */
  const [openFilterSide, setOpenFilterSide] = useState(null);

  useEffect(() => {
    setLeftAttrID(element.leftAttrID);
    setRightAttrID(element.rightAttrID);
    setSubConditionOp(element.subConditionOp);
  }, [element]);

  const handleSaveFilters = () => {
    savedFiltersLeft = JSON.parse(JSON.stringify(element.leftFilters));
    savedFiltersRight = JSON.parse(JSON.stringify(element.rightFilters));
  };

  return (
    <div className="sub-condition">
      <div className="left-parenthesis" />
        <div className="right-indent">
            <RightButton onClick={() => { ruleDispatch({ type: "RIGHT_INDENT", position: position})}} />
            <div className="tw-py-1 tw-bg-surface"></div>  
            <LeftButton onClick={() => { ruleDispatch({ type: "LEFT_INDENT", position: position})}} />
        </div>
      {/* <div className="left-indent">
      </div> */}
      <div className="left-category ">
        <div className="tw-flex tw-justify-between tw-items-center">
          <div>
            <label className="tw-text-ink tw-font-semibold tw-text-sm"> {selectedCategories.leftCategory.name}</label>
          </div>
          <div>
          <a data-testid="rulebuilder-subcondition-a-1"
            className="add-logic-filter-button"
            href={`#left-filters-for-${element.position}`}
            onClick={(event) => {
              /* The href stays real for identity; Bootstrap used to swallow the
                 jump — now the handler does. Same handleSaveFilters call, then
                 the DS Dialog opens instead of data-bs-toggle. */
              event.preventDefault();
              handleSaveFilters();
              setOpenFilterSide(LEFT);
            }}
          >
            Add Filters
          </a>
        </div>
        </div>
        <SubConditionFilter filters={element.leftFilters} />
        &emsp;
        
        <Filters
          targetID={`left-filters-for-${position}`}
          {...{
            attributesList: attributesList.leftAttributes,
            filters: element.leftFilters,
            side: LEFT,
            rulePos: position,
          }}
          savedFilters={savedFiltersLeft}
          isOpen={openFilterSide === LEFT}
          onClose={() => setOpenFilterSide(null)}
        />
      </div>

      {/*<div className="left-attributes rb">a</div>*/}
      
        {ruleType === CBA_RULE ? <div className="left-attributes">
          <select
            data-testid="rule-subcondition-left-attribute-select"
            className="form-select drop-down-dm tw-ps-2 tw-bg-surface tw-text-ink"
            id="rightCategoryId"
            aria-label="RuleBody Status"
            style={{
              fontSize: ".8rem",
              color: "var(--ds-ink, #172b4d)",
              fontWeight: "300",
              fontFamily: "Noto Sans",
            }}
            value={leftAttrID}
            onChange={(el) => {
              ruleDispatch({
                type: "SET_LEFT_ATTR",
                leftAttrID: el.target.value,
                position: position,
              })
            }
            }
          >
            <option selected>Select Attribute</option>
            {attributesList.leftAttributes.map((attr, index) => {
              return (
                <option value={attr.id} key={attr.id}>
                  {attr.name}
                </option>
              );
            })}
          </select>
        </div>: null}
      {ruleType === CBA_RULE ? (
        <div className="center-compatible-text">
          <select data-testid="rulebuilder-subcondition-select-1"
            className="form-select drop-down-dm tw-bg-surface tw-text-ink"
            id="se"
            aria-label="RuleBody Status"
            value={subConditionOp}
            style={{
              textAlign: "center",
              fontSize: ".8rem",
              color: "var(--ds-ink, #172b4d)",
              fontWeight: "600",
            }}
            onChange={(el) =>
              ruleDispatch({
                type: "SET_COND_OP",
                subConditionOp: el.target.value,
                position: position,
              })
            }
          >
            <option value={GT}>{">"}</option>
            <option value={LT}> {"<"} </option>
            <option value={GTE}>{">="}</option>
            <option value={LTE}>{"<="}</option>
            <option selected value={EQ}>{"=="}</option>
            <option value={IS_NOT}>{"!="}</option>
          </select>
        </div>
      ) : (
        <div className="center-compatible-text tw-text-ink tw-text-sm tw-mt-2">are compatible with</div>
      )}
      <div className="right-parenthesis" />

      {/*<div className="right-parenthesis"/>*/}

      {/*<div className="right-opening-parenthesis"/>*/}
      <div className="right-category">
        <div className="tw-flex tw-justify-between tw-items-center">
          <div>
            <label className="tw-text-ink tw-font-semibold tw-text-sm">{selectedCategories.rightCategory.name}</label>
          </div>
          <div>
            <a data-testid="rulebuilder-subcondition-a-2"
              className="add-logic-filter-button"
              href={`#right-filters-for-${element.position}`}
              onClick={(event) => {
                event.preventDefault();
                handleSaveFilters();
                setOpenFilterSide(RIGHT);
              }}
            >
              Add Filters
            </a>
          </div>
        </div>
        <SubConditionFilter filters={element.rightFilters} />
        {/* For every &nbsp;
        <span>{selectedCategories.rightCategory.name}</span> &emsp; */}
        &emsp;
        
        <Filters
          targetID={`right-filters-for-${position}`}
          {...{
            attributesList: attributesList.rightAttributes,
            filters: element.rightFilters,
            side: RIGHT,
            rulePos: position,
          }}
          savedFilters={savedFiltersRight}
          isOpen={openFilterSide === RIGHT}
          onClose={() => setOpenFilterSide(null)}
        />
      </div>
     
        <>
          {/*<div className="right-attributes "></div>*/}
          <div className="right-opening-parenthesis" />
          {ruleType === CBA_RULE ?<div className="right-attributes">
            <select data-testid="rulebuilder-subcondition-select-2"
              className="form-select drop-down-dm tw-ps-2 tw-ms-2 tw-bg-surface tw-text-ink"
              id="rightCategoryId"
              aria-label="RuleBody Status"
              style={{
                fontSize: ".8rem",
                color: "var(--ds-ink, #172b4d)",
                fontWeight: "300",
                fontFamily: "Noto Sans",
              }}
              value={rightAttrID}
              onChange={(el) =>
                ruleDispatch({
                  type: "SET_RIGHT_ATTR",
                  rightAttrID: el.target.value,
                  position: position,
                })
              }
            >
              <option selected>Select Attribute</option>
              {attributesList.rightAttributes.map((attr, index) => {
                return (
                  <option value={attr.id} key={index}>
                    {attr.name}
                  </option>
                );
              })}
            </select>
          </div> : null}
        </>
      

      <div className="right-closing-parenthesis" />

      <div className="mt-1 delete-btn-cba d-flex align-items-center">
        <div>
          <button aria-label="Delete" data-testid="rulebuilder-subcondition-button-3"
            className="delete-button icon-follow-ink tw-text-ink-tertiary"
            onClick={() => {
              ruleDispatch({
                type: "DELETE_CONDITION",
                position: position,
              });
            }}
          >
            <DeleteIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubCondition;
